import { DBSelectedPlan } from 'db/schema/selectedPlans';
import { MedicareApiPlan } from 'types/api';
import { DEFAULT_PLAN_YEAR } from 'lib/planYears';

export const isSamePlan = (
  left: Pick<MedicareApiPlan, 'id' | 'planYear'>,
  right: Pick<MedicareApiPlan, 'id' | 'planYear'>
): boolean =>
  left.id === right.id &&
  (left.planYear ?? DEFAULT_PLAN_YEAR) ===
    (right.planYear ?? DEFAULT_PLAN_YEAR);

export const planIdentityKey = (
  plan: Pick<MedicareApiPlan, 'id' | 'planYear'>
): string => `${plan.planYear ?? DEFAULT_PLAN_YEAR}:${plan.id}`;

export const filterPlansByYear = (
  plans: MedicareApiPlan[],
  year: number
): MedicareApiPlan[] =>
  plans.filter((plan) => (plan.planYear ?? DEFAULT_PLAN_YEAR) === year);

export const overlayStatesByYear = (
  existing: Record<number, string[]>,
  incoming: Record<number, string[]>
): Record<number, string[]> => ({ ...existing, ...incoming });

export const matchSelectedPlanRows = <
  T extends Pick<DBSelectedPlan, 'id' | 'plan_id' | 'status'> & {
    year?: number | null;
  }
>(
  rows: T[],
  planId: string,
  status: string,
  year?: number
): T[] =>
  rows.filter(
    (row) =>
      row.plan_id === planId &&
      row.status === status &&
      (year === undefined || row.year === year)
  );

export const uniquePlansById = (
  plans: MedicareApiPlan[]
): MedicareApiPlan[] => {
  const seen = new Set<string>();
  return plans.filter((plan) => {
    const key = planIdentityKey(plan);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
